import {createPaymentColumns, useGetUserPayouts} from '@entities/transaction';
import {ROUTE__WITHDRAWAL_FULL_INFO} from '@shared/constants';
import {PaymentsTab} from './PaymentsTab';

const columns = createPaymentColumns(ROUTE__WITHDRAWAL_FULL_INFO, {
  showLocalAmount: true,
});

export const WithdrawalsTab = () => (
  <PaymentsTab
    useGetPayments={useGetUserPayouts}
    columns={columns}
    localStorageKey="userAccountWithdrawalTable"
  />
);
